// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface IDocumentFileUploadByQrCodeDto
 */
export interface IDocumentFileUploadByQrCodeDto {
    /**
     * 
     * @type {string}
     * @memberof IDocumentFileUploadByQrCodeDto
     */
    qr_id: string;
    /**
     * 
     * @type {string}
     * @memberof IDocumentFileUploadByQrCodeDto
     */
    object_key: string;
    /**
     * 
     * @type {number}
     * @memberof IDocumentFileUploadByQrCodeDto
     */
    employee_id: number;
    /**
     * 
     * @type {string}
     * @memberof IDocumentFileUploadByQrCodeDto
     */
    file_name: string;
}

/**
 * Check if a given object implements the IDocumentFileUploadByQrCodeDto interface.
 */
export function instanceOfIDocumentFileUploadByQrCodeDto(value: object): value is IDocumentFileUploadByQrCodeDto {
    if (!('qr_id' in value) || value['qr_id'] === undefined) return false;
    if (!('object_key' in value) || value['object_key'] === undefined) return false;
    if (!('employee_id' in value) || value['employee_id'] === undefined) return false;
    if (!('file_name' in value) || value['file_name'] === undefined) return false;
    return true;
}

export function IDocumentFileUploadByQrCodeDtoFromJSON(json: any): IDocumentFileUploadByQrCodeDto {
    return IDocumentFileUploadByQrCodeDtoFromJSONTyped(json, false);
}

export function IDocumentFileUploadByQrCodeDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): IDocumentFileUploadByQrCodeDto {
    if (json == null) {
        return json;
    }
    return {
        
        'qr_id': json['qr_id'],
        'object_key': json['object_key'],
        'employee_id': json['employee_id'],
        'file_name': json['file_name'],
    };
}

export function IDocumentFileUploadByQrCodeDtoToJSON(json: any): IDocumentFileUploadByQrCodeDto {
    return IDocumentFileUploadByQrCodeDtoToJSONTyped(json, false);
}

export function IDocumentFileUploadByQrCodeDtoToJSONTyped(value?: IDocumentFileUploadByQrCodeDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'qr_id': value['qr_id'],
        'object_key': value['object_key'],
        'employee_id': value['employee_id'],
        'file_name': value['file_name'],
    };
}

